/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from './'
import $const from '../common/constant'

export default {

  //根据parentCode 获取树形部门列表
  getTree: params => {
    return API.GET($const.apiServer.Admin + '/dept/tree', params);
  },
  getNewTree: params => {
    return API.GET($const.apiServer.Admin + '/new/dept/tree', params);
  },
  dropDownTree: params => {
    return API.GET($const.apiServer.Admin + '/new/dept/dropDownTree', params);
  },
  getDeptTreeWithSubsidiary: params => {
    return API.GET($const.apiServer.Admin + '/dept/treeWithSubsidiary', params);
  },
  update: (params, config) => {
    return API.POST($const.apiServer.Admin + '/dept/update', params, config);
  },
  save: (params, config) => {
    return API.POST($const.apiServer.Admin + '/dept/save', params, config);
  },
  remove: params => {
    return API.GET($const.apiServer.Admin + '/dept/remove', params);
  },
  getIdsByUserId: params => {
    return API.GET($const.apiServer.Admin + '/dept/getIdsByUserId', params);
  },
  getStructureUrl: params => {
    return API.GET($const.apiServer.Admin + '/dept/getStructureUrl', params);
  },
  getDeptByUserId: id => {
    return API.GET($const.apiServer.Admin + '/dept/getDeptByUserId?userId=' + id);
  },
  getlistAll: params => {
    return API.GET($const.apiServer.Admin + '/dept/listAll', params);
  },
  getlistAllNew: params => {
    return API.GET($const.apiServer.Admin + '/dept/list', params);
  },
  //根据parentCode 获取树形部门列表
  getTreeByUserId: params => {
    return API.GET($const.apiServer.Admin + '/dept/treeByUserId', params);
  },
  /**
   * 生成企业组织架构图
   * @return
   */
  getUserList: params => {
    return API.GET($const.apiServer.Admin + '/user/getEnterpriseIdUser', params);
  },
  getOrganizationTree: params => {
    return API.GET($const.apiServer.Admin + '/dept/getOrganizationTree', params);
  },
  getTreeDeptAndUser: params => {
    return API.GET($const.apiServer.Admin + '/dept/getTreeDeptAndUser', params);
  },
  getDeptNodeById: id => {
    return API.GET($const.apiServer.Admin + '/dept/getById?id=' + id);
  },
  listUserAllDeptTree: () => {
    return API.GET($const.apiServer.Admin + '/dept/listUserAllDeptTree');
  },
  putdeptfileter: (params) => {
    return API.GET($const.apiServer.Admin + '/dept/putdeptfileter', params);
  },
  getdeptfileter: (params) => {
    return API.GET($const.apiServer.Admin + '/dept/getdeptfileter', params);
  },
  getEnableRemoveDept: (params) => {
    return API.GET($const.apiServer.Admin + '/dept/getEnableRemoveDept', params);
  },
  getByEmployee: (params) => {
    return API.GET($const.apiServer.CMS + '/employee/getByEmployee', params);
  },
  deptSaveValid: (params) => {
    return API.POST($const.apiServer.Admin + '/dept/deptSaveValid', params);
  },
  getSafeUser: deptId => {
    return API.GET($const.apiServer.Admin + '/new/dept/getSafeUser?deptId=' + deptId);
  },

}



// WEBPACK FOOTER //
// ./src/api/api_dept.js